import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { cn } from '../utils';

const AuthCTA = ({ message, variant = 'indigo' }) => {
  const variants = {
    purple: {
      bg: 'bg-purple-50',
      border: 'border-purple-100',
      button: 'bg-purple-600 hover:bg-purple-700 shadow-purple-100',
      text: 'text-gray-600',
      icon: 'text-white'
    },
    green: {
      bg: 'bg-green-50',
      border: 'border-green-100',
      button: 'bg-green-600 hover:bg-green-700 shadow-green-100',
      text: 'text-gray-600',
      icon: 'text-white'
    },
    indigo: {
      bg: 'bg-brand-indigo/10',
      border: 'border-brand-indigo/10',
      button: 'bg-brand-indigo hover:bg-brand-indigo/90 shadow-brand-indigo/10',
      text: 'text-gray-600',
      icon: 'text-white'
    },
    orange: {
      bg: 'bg-brand-accent/10',
      border: 'border-brand-accent/10',
      button: 'bg-brand-accent hover:bg-brand-accent/90 shadow-brand-accent/10',
      text: 'text-gray-600',
      icon: 'text-white'
    }
  };

  const style = variants[variant] || variants.indigo;

  return (
    <div className={cn(
      "p-4 rounded-3xl border flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left",
      style.bg,
      style.border
    )}>
      <p className="text-[11px] font-bold text-gray-600">{message}</p>
      <Link 
        to="/login" 
        className={cn(
          "flex items-center gap-1.5 px-4 py-2 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.15em] transition-all shadow-lg shrink-0 active:scale-95",
          style.button
        )}
      >
        <LogIn size={14} className={style.icon} />
        Login
      </Link>
    </div>
  );
};

export default AuthCTA;
